import React from 'react';
import PropTypes from 'prop-types';
import PatientDisplayId from 'App/components/PatientDisplayId/PatientDisplayId';
import './PatientIdentityHeader.scss';

const PatientIdentityHeader = ({ patient }) => {
    return (
        <div className="patient-identity-header">
            <div className="patient-identity-header-top">
                <span className="patient-name">
                    {patient.firstName} {patient.lastName}
                </span>
                <span className="patient-id">
                    {patient.id ? <PatientDisplayId patientId={patient.id} fallback={patient.humanId} /> : null}
                </span>
            </div>
            <div className="patient-identity-header-down">
                <span className="patient-synced-info">View only • synced from EHR</span>
            </div>
        </div>
    );
};

PatientIdentityHeader.propTypes = {
    patient: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        id: PropTypes.string,
        humanId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
};

export default PatientIdentityHeader;
